import { toggleScroll } from 'PARENT/utilities/toggleScroll.js';


window.addEventListener( 'DOMContentLoaded', () => {
    initDialogListeners();
} );

function initDialogListeners() {
    document.body.addEventListener( 'click', ( e ) => {
        const target = e.target;

        const maybeOpener = /** @type {HTMLButtonElement|null} */ ( target?.closest( '[data-dialog]' ) );
        if ( maybeOpener ) return onOpenerClick( maybeOpener, e );

        const maybeCloser = /** @type {HTMLButtonElement|null} */ ( target?.closest( '[data-dialog-close]' ) );
        if ( maybeCloser ) return onCloserClick( maybeCloser, e );

    } );

    // close event doesn't bubble so listeners need to be added on each dialog
    const dialogs = document.querySelectorAll( 'dialog' );
    dialogs.forEach( ( dialog ) => {
        // ALWAYS reset scroll on dialog close, required for closing with ESC
        dialog.addEventListener( 'close', ( e ) => {
            toggleScroll( true );
        } );
    } );

    /**
     * @param {HTMLButtonElement} trigger
     * @param {MouseEvent} e
     *
     * @return void
     */
    function onOpenerClick( trigger, e ) {
        const dialogName = trigger.getAttribute( 'data-dialog' );
        const dialog = document.querySelector( `dialog#${dialogName}` );
        const asModal = trigger.getAttribute( 'data-is-modal' ) ?? 'true';

        if ( !dialog ) {
            console.warn( 'No dialog with ID: ' + dialogName );
            return;
        }

        openDialog( dialog, asModal === 'true' );
    }

    /**
     * @param {HTMLButtonElement} trigger
     * @param {MouseEvent} e
     *
     * @return void
     */
    function onCloserClick( trigger, e ) {
        const dialog = trigger.closest( 'dialog' );
        if ( !dialog ) return;
        closeDialog( dialog );
    }
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function openDialog( dialog, asModal = true ) {
    asModal ? dialog.showModal() : dialog.show();
    dialog.classList.add( 'dialog-is-open' );
    if ( asModal ) toggleScroll( false );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function closeDialog( dialog ) {
    const closeHandler = ( e ) => {
        if ( e.target !== dialog ) return;
        dialog.close();
        dialog.removeEventListener( 'transitionend', closeHandler );
    };
    toggleScroll( true );
    dialog.addEventListener( 'transitionend', closeHandler );
    dialog.classList.remove( 'dialog-is-open' );
}